export default "__VITE_ASSET__ee766e27__"